import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-favorite",
  "use": "icon-favorite-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-favorite\"><g fill-rule=\"evenodd\"><circle cx=\"14\" cy=\"14\" r=\"14\" /><path fill=\"#FFF\" d=\"M14 18.375l-5.143 2.704.982-5.727-4.16-4.056 5.75-.835L14 5.25l2.572 5.21 5.75.836-4.161 4.056.982 5.727z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol